import styles from './styles.module.scss';
export const getTitle = (rule) => {
  const name = rule?.title;
  if (name) return name.toUpperCase();
};
